import { render, staticRenderFns } from "./MultipleSubQuestion.vue?vue&type=template&id=5052d90e&scoped=true"
import script from "./MultipleSubQuestion.vue?vue&type=script&lang=js"
export * from "./MultipleSubQuestion.vue?vue&type=script&lang=js"
import style0 from "./MultipleSubQuestion.vue?vue&type=style&index=0&id=5052d90e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5052d90e",
  null
  
)

export default component.exports